var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          { staticClass: "form-wrapper", attrs: { validator: _vm.$v.addNote } },
          [
            _c(
              "form-group",
              { staticClass: "custom-textarea", attrs: { name: "role" } },
              [
                _c("md-textarea", {
                  directives: [{ name: "focus", rawName: "v-focus" }],
                  attrs: { "md-debounce": 100 },
                  on: { input: _vm.update },
                  model: {
                    value: _vm.form.note,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "note", $$v)
                    },
                    expression: "form.note",
                  },
                }),
              ],
              1
            ),
            _c("input", {
              ref: "file",
              attrs: {
                type: "file",
                multiple: "",
                accept:
                  ".pdf,.xlsx,.xls,.txt,.ppt,.pptx,.docx,.doc,.mp4, .png, .gif, .jpeg, .jpg, .bmp, .webp",
              },
              on: { change: _vm.onChange },
            }),
            _c("div", { staticClass: "note-type-container" }, [
              _c(
                "div",
                { staticClass: "type-field" },
                [
                  _c("label", { staticClass: "custom-label" }, [
                    _vm._v("Type"),
                  ]),
                  _c("vue-select", {
                    attrs: {
                      reduce: function (x) {
                        return x.name
                      },
                      label: "name",
                      options: _vm.noteTypes,
                      placeholder: "Status",
                      searchable: _vm.$root.isDesktop,
                      clearable: false,
                    },
                    model: {
                      value: _vm.form.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type", $$v)
                      },
                      expression: "form.type",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: { click: _vm.saveNote },
          },
          [_vm._v("\n            Save\n        ")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("\n            Cancel\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Add Note")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }